module.exports = __webpack_public_path__ + "static/media/96gal07.7bcb01ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/96gal/96gal07.jpg
// module id = 235
// module chunks = 0